import { SubmissionError } from 'redux-form';

import {
  fetch,
  normalize,
  mercureSubscribe as subscribe
} from '../../utils/dataAccess';

export function error(error) {
  return { type: 'CHECKOUT_LIST_ERROR', error };
}

export function loading(loading) {
  return { type: 'CHECKOUT_LIST_LOADING', loading };
}

export function success(retrieved) {
  return { type: 'CHECKOUT_LIST_SUCCESS', retrieved };
}

export function list(page = 'checkout') {
  return dispatch => {
    dispatch(loading(true));

    return fetch(page, { method: 'GET' })
      .then(response => {
        dispatch(loading(false));
        return response.json();
      })
      .then(retrieved => dispatch(success(retrieved)))
      .catch(e => {
        dispatch(loading(false));

        if (e instanceof SubmissionError) {
          dispatch(error(e.errors._error));
          throw e;
        }

        dispatch(error(e.message));
      });
  };
}

export function reset(eventSource) {
  return dispatch => {
    if (eventSource) eventSource.close();

    dispatch({ type: 'CHECKOUT_LIST_RESET' });
  };
}

export function mercureSubscribe(hubURL, topics) {
  return dispatch => {
    const eventSource = subscribe(hubURL, topics);
    dispatch(mercureOpen(eventSource));
    eventSource.addEventListener('message', event =>
      dispatch(mercureMessage(normalize(JSON.parse(event.data))))
    );
  };
}

export function mercureOpen(eventSource) {
  return { type: 'CHECKOUT_LIST_MERCURE_OPEN', eventSource };
}

export function mercureMessage(retrieved) {
  return dispatch => {
    if (1 === Object.keys(retrieved).length) {
      dispatch({
        type: 'CHECKOUT_LIST_MERCURE_DELETED',
        retrieved
      });
      return;
    }
    dispatch({ type: 'CHECKOUT_LIST_MERCURE_MESSAGE', retrieved });
  };
}
